import {Box, Button, TextField} from "@mui/material";
import useLogin from "../hooks/useLogin";
import React from "react";

const LoginForm = () => {

    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');


    const tokenQuery = useLogin();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        tokenQuery.mutate({username, password});
    }

    let errorDiv;

    if (tokenQuery.isError) {
        if ((tokenQuery.error as Error).message.includes('401')) {
            errorDiv = <div
                style={{color: "#d32f2f"
                }}>
                ABK-Nummer und Lizenzschlüssel stimmen nicht überein. <br/>
                Bitte überprüfen Sie die Angaben und versuchen Sie
                es erneut.
            </div>
        } else {
            errorDiv =
                <div style={{color: "#d32f2f"}}>Bei der Anmeldung ist ein Fehler aufgetreten. <br/>
                    Bitte versuchen Sie es erneut oder kontaktieren Sie
                    uns. </div>
        }

    } else {
        errorDiv = <span style={{display: "none"}}></span>
    }


    // @ts-ignore
    return (
        <Box component="form" onSubmit={e => handleSubmit(e)} noValidate sx={{mt: 1}}>
            <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="ABK-Nummer"
                name="username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                autoFocus
                error={tokenQuery.isError}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Lizenzschlüssel"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                error={tokenQuery.isError}
            />

            {errorDiv}

            <Button type="submit" fullWidth variant="contained" sx={{mt: 3, mb: 2}}>
                {tokenQuery.isLoading ? "Wird geladen..." : "Anmelden"}
            </Button>
        </Box>
    );
};

export default LoginForm;
